import { AText, Box } from '@alf/uikit';
import { useI18n } from '@namespace/i18n';
import { FilterDrawer } from '../FilterDrawer';

import styles from './index.module.css';

export const GamesSearchFilterDrawer = ({
  filterId = '',
  children,
  onResetClick,
  onApplyClick,
  onDrawerCloseClick,
  titleTextKey,
  filterBodyTextKey,
  toggleDrawer,
  wasFilterChanged,
  isFilterFilled,
  isOpen
}) => {
  const { t } = useI18n();

  return (
    <FilterDrawer
      onToggle={() => {
        toggleDrawer();
        onDrawerCloseClick();
      }}
      title={
        <AText breed="BU" size="l" color="txt_color_4">
          {t(titleTextKey)}
        </AText>
      }
      onResetClick={onResetClick}
      onApplyClick={() => {
        onApplyClick();
        toggleDrawer();
      }}
      {...{ wasFilterChanged, isFilterFilled, filterId, isOpen }}
    >
      <Box
        direction="column"
        padding="m"
        className={styles.drawerBodyContainer}
      >
        <Box justify="center">
          <AText size="m" color="txt_color_1">
            {t(filterBodyTextKey)}
          </AText>
        </Box>
        {children}
      </Box>
    </FilterDrawer>
  );
};
